var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-stepped',{attrs:{"title":_vm.title,"breadcrumbs":_vm.breadcrumbs,"steps":_vm.steps,"model":_vm.model,"fetch-endpoint":_vm.fetchAutomationsEndpoint,"save-endpoint":_vm.saveEndpoint,"after-save":_vm.afterSave,"rules":_vm.rules,"is-edit":_vm.isEditPage,"readonly":_vm.readonly},on:{"clear-errors":_vm.clearErrors}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18f96ba2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/automations/pages/ExportFormPage.vue
// module id = null
// module chunks = 